import axios from "axios";
import { baseUrl } from "../utils/baseUrl";
import { axiosInterceptors } from "../components/Reusable/axiosInterceptors";

// Clean v1 API surface (api.mega.software/api/v1 in prod). Additive — the
// legacy domain-prefixed instances (/api/Appointment, /api/Customer, ...)
// stay live for iOS. Routes are relative to /api/v1 (e.g. "/calendar").
const v1Instance = axios.create({
  baseURL: `${baseUrl}/api/v1`,
  headers: {
    "Content-Type": "application/json",
  },
});
axiosInterceptors(v1Instance);
export default v1Instance;
